import React from 'react';
import * as Styled from './styled';
import { InputProps } from '@material-ui/core';

const Input: React.ComponentType<InputProps> = props => <Styled.Input disableUnderline={true} {...props} />;

export default Input;
